import styled from 'styled-components';

import Button from '@mlb/react-patterns/components/Button/button.tsx';
import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';

const PopoverButton = styled(Button).attrs(({ ...otherProps }) => ({
    iconSize: 13,
    size: 'sm',
    styleName: 'default',
    shape: 'hollow-borderless',
    ...otherProps,
}))`
    width: 92vw;
    text-align: left;
    white-space: nowrap;
    ${IconWrapper} {
        stroke: none;
    }
`;

export default PopoverButton;
